import React from 'react';
import { CatHeadline, IdInput, IdResult, IdInfo, InpRadio, BtnCreate, CatTitle, ColLow, GroupBox, ColContainer, Cols, BtnDownload, SingleRow, BtnCoffee, InpSlider, InpCheckbox, InpRadioGroup } from '../components/component';
import { DefaultLink } from '../components/jptr-default.js';
import { useState, useEffect } from 'react';
import { ImgComparisonSlider } from '@img-comparison-slider/react';

import { CloudStrike } from '../base/clrsplt-CloudConnect';

import ImgTrans from '../base/images/depot/TransSquare7.png';
import { Swatch, SwatchList } from '../components/swatch.js';
import { Select } from '@react-three/drei';


function UnderbaseFlood({ onClick }) {

    const [funcName,] = useState('flood');
    const [expansion, setExpansion] = useState(0);
    const [intensity, setIntensity] = useState(100);

    const handleExpansionSlider = (value) => {
        setExpansion(value);
    }

    const handleIntensitySlider = (value) => {
        setIntensity(value);
    }

    const handleCreate = () => {

        const json = {
            funcName: funcName,
            settings: {
                expansion: expansion,
                intensity: intensity
            }
        }
        if (onClick)
            onClick(json);
    }

    return (
        <ColLow>
            <CatTitle name={`settings ${funcName}`} />
            <p>
                The complete image is underbased.
            </p>
            <InpSlider name='expansion' min={-20} max={0} value={expansion} unit={'px'} step={1} onSliderChange={handleExpansionSlider} />
            <InpSlider name='intensity' min={0} max={100} value={intensity} onSliderChange={handleIntensitySlider} />
            {/* <InpCheckbox name='Invert' /> */}
            <BtnCreate label='flood' onClick={handleCreate} />
        </ColLow>
    );
};

function UnderbaseFill({ onClick }) {

    const [funcName,] = useState('fill');
    const [expansion, setExpansion] = useState(0);
    const [intensity, setIntensity] = useState(100);
    const [invert, setInvert] = useState(false);

    const handleExpansionSlider = (value) => {
        setExpansion(value);
    }

    const handleIntensitySlider = (value) => {
        setIntensity(value);
    }

    const handleInvertChange = () => {
        setInvert(!invert);
    }

    const handleCreate = () => {

        const json = {
            funcName: funcName,
            invert: invert,
            settings: {
                expansion: expansion,
                intensity: intensity
            }
        }
        if (onClick)
            onClick(json);
    }

    return (
        <ColLow>
            <CatTitle name={`settings ${funcName}`} />
            <InpSlider name='expansion' min={-10} max={10} value={expansion} unit={'px'} step={1} onSliderChange={handleExpansionSlider} />
            <InpSlider name='intensity' min={0} max={100} value={intensity} onSliderChange={handleIntensitySlider} />
            <InpCheckbox name='Invert' value={invert} onChange={handleInvertChange} />
            <BtnCreate label='Fill' onClick={handleCreate} />
        </ColLow>
    );
};

function UnderbasePixel({ onClick }) {

    const [funcName, setFuncName] = useState('pixel');
    const [expansion, setExpansion] = useState(0);
    /* const [intensity, setIntensity] = useState(100); */
    const [invert, setInvert] = useState(false);

    const handleExpansionSlider = (value) => {
        setExpansion(value);
    }

    /*     const handleIntensitySlider = (value) => {
            setIntensity(value);
        } */

    const handleInvertChange = () => {
        setInvert(!invert);
    }

    const handleCreate = () => {

        const json = {
            funcName: funcName,
            invert: invert,
            settings: {
                expansion: expansion,
                /* intensity: intensity */
            }
        }
        if (onClick)
            onClick(json);
    }

    return (
        <ColLow>
            <CatTitle name={`settings ${funcName}`} />
            <InpSlider name='expansion' min={-10} max={10} value={expansion} unit={'px'} step={1} onSliderChange={handleExpansionSlider} />
            {/*             <InpSlider name='intensity' min={0} max={100} value={intensity} onSliderChange={handleIntensitySlider} />
 */}            <InpCheckbox name='Invert' value={invert} onChange={handleInvertChange} />
            <BtnCreate label='pixel' onClick={handleCreate} />
        </ColLow>
    );
};

function UnderbaseSum({ onClick }) {

    const [funcName, setFuncName] = useState('sum');
    const [expansion, setExpansion] = useState(0);
    const [intensity, setIntensity] = useState(100);

    const handleExpansionSlider = (value) => {
        setExpansion(value);
    }

    const handleIntensitySlider = (value) => {
        setIntensity(value);
    }

    const handleCreate = () => {

        const json = {
            funcName: funcName,
            expansion: expansion,
            intensity: intensity
        }
        if (onClick)
            onClick(json);
    }

    return (
        <ColLow>
            <CatTitle name={`settings ${funcName}`} />
            <InpSlider name='expansion' min={0} max={20} value={expansion} unit={'px'} step={1} onSliderChange={handleExpansionSlider} />
            <InpSlider name='intensity' min={0} max={100} value={intensity} onSliderChange={handleIntensitySlider} />
            {/* <InpCheckbox name='Invert' /> */}
            <BtnCreate label='sum' onClick={handleCreate} />
        </ColLow>
    );
};

export default function Cntntmrg() {

    const [previewSize, setPreviewSize] = useState(900);
    const refContainer = React.createRef();

    const [imgId, setImgId] = useState(DefaultLink.ID);
    const [imgData, setImgData] = useState(null);

    const [sisData, setSisData] = useState(null);

    useEffect(() => {
        const container = refContainer.current;
        if (container) {
            setPreviewSize(container.offsetWidth);
        }
    }, [refContainer]);

    const [sliderPosition, setSliderPosition] = useState(100);
    useEffect(() => {
        const sliderValue = (sisData !== null) ? 50 : 100;
        setSliderPosition(sliderValue);
    }, [sisData]);

    const handleImageIdChange = async (newId) => {

        setImgId(DefaultLink.ID);
        setImgData(null);
        setSisData(null);

        if (newId === '' || !newId) {
            return;
        }

        setImgId(newId);
        /* saveIdToLocalStorage(StorageID.image, newId); */
        getPreview(newId, setImgData);
        /* getStatus(newId); */
    }



    /* const [sistyp, setSisTyp] = useState('Underbase'); */
    /* const [sisShow, setSisShow] = useState(false); */
    const handleSis = async (type, inkOdj = {}) => {

        const strike = new CloudStrike();
        strike.createSpecialInkSeparation(imgId, previewSize, type, inkOdj)
            .then(async data => {
                if (data.sisPrvID) {
                    await strike.downloadPreview(data.sisPrvID)
                        .then(prvdata => { setSisData(prvdata); })
                }
            })
            .catch(error => { throw error; });
    }

    const handleSisComponent = async (json) => {
        //console.log('Sis Component:', json);
        //console.log(typeof json.invert);

        const method = json.funcName;
        const inkOdj = json.settings;

        let algo = null;

        if (method === 'flood') {
            algo = 'flood';
        }
        else if (method === 'fill' && json.invert === false) {
            algo = 'fill';
        }
        else if (method === 'fill' && json.invert === true) {
            algo = 'selective';
        }
        else if (method === 'pixel' && json.invert === false) {
            algo = 'pixel';
        }
        else if (method === 'pixel' && json.invert === true) {
            algo = 'pixelinvert';
        }
        else if (method === 'sum') {
            algo = 'pixelsum';
        }

        if (algo !== null) {
            await handleSis(algo, inkOdj);
        }
    }

    async function getPreview(file_id, onImageChange) {

        const strike = new CloudStrike();
        return strike.downloadPreview(file_id)
            .then(prvdata => {
                if (onImageChange) {
                    /* console.log('Preview Size: ', prvdata.length); */
                    onImageChange(prvdata);
                }
                else {
                    return prvdata;
                }
            })
            .catch(error => { throw error; });
    }

    const [bgColors, setBgColors] = useState(['rgb(14, 35, 69)', 'rgb(220, 217, 215)', 'rgb(143, 143, 143)', 'rgb(0, 0, 0)', 'rgb(15, 91, 43)', 'rgb(233, 112, 20)', 'rgb(97, 49, 12)']);
    const [usedBgColor, setUsedBgColor] = useState('rgb(14, 35, 69)');

    const handleBgChange = (value) => {
        /* console.log('Background:', value); */
        setUsedBgColor(bgColors[value]);
    }


    const [selectedOption, setSelectedOption] = useState('flood');
    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);
        /* console.log('Selected Option:', event.target.value); */
    };

    return (
        <div className='flx-Vl-6'>
            <div className='flx-2row-600na'>
                <ColContainer>
                    <ColLow>
                        <CatHeadline name="underbase" />
                        <p style={{ color: 'var(--c3)' }}>These options are not yet implemented.</p>
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
                            et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.
                        </p>
                    </ColLow>
                    <GroupBox>
                        <Cols>
                            <ColLow >
                                <CatTitle name="Image-ID" />
                                <IdInput placeholder='(optional) IMAGE-ID' value={imgId !== DefaultLink.ID ? imgId : ''} onChange={handleImageIdChange} isAvaliable={imgData !== null} />
                            </ColLow>
                            <ColLow >
                                <CatTitle name="method" />
                                {/* <select value={selectedOption} onChange={handleSelectChange}>
                                    <option value="flood">Flood</option>
                                    <option value="fill">Fill</option>
                                    <option value="pixel">Pixel</option>
                                    <option value="sum">Sum</option>
                                </select> */}
                                <InpRadioGroup value={selectedOption} onChange={handleSelectChange}>
                                    <SingleRow style={{ gap: '4em' }}>
                                        <div>
                                            <InpRadio group='method' value='flood' checked={true} />
                                            <InpRadio group='method' value='fill' />
                                        </div>
                                        <div>
                                            <InpRadio group='method' value='pixel' />
                                            <InpRadio group='method' value='sum' />
                                        </div>
                                        {/* <div>
                                            <InpRadio group='method' value='white' />
                                            <InpRadio group='method' value='black' />
                                        </div> */}
                                    </SingleRow>
                                </InpRadioGroup>
                            </ColLow>
                            <ColLow >
                                {selectedOption === 'flood' && (<UnderbaseFlood onClick={handleSisComponent} />)}
                                {selectedOption === 'fill' && (<UnderbaseFill onClick={handleSisComponent} />)}
                                {selectedOption === 'pixel' && (<UnderbasePixel onClick={handleSisComponent} />)}
                                {selectedOption === 'sum' && (<UnderbaseSum onClick={handleSisComponent} />)}
                            </ColLow>
                        </Cols>
                    </GroupBox>
                </ColContainer>

                <ColContainer>
                    <Cols >
                        <ImgComparisonSlider ref={refContainer}
                            className="ics"
                            value={sliderPosition}
                            onInput={(event) => setSliderPosition(event.target.value)}
                            style={{
                                backgroundColor: usedBgColor,
                                /* backgroundImage: `url(${ImgTrans})`, 
                                backgroundRepeat: 'repeat' */
                            }}
                        >
                            <figure slot="first" className="befor" >
                                <img src={imgData} alt='-' style={{ transform: 'scale(0.90)' }} />
                                {/* <figcaption>Input</figcaption> */}
                            </figure>
                            <figure slot="second" className="after" >
                                <img src={sisData} alt='-' style={{ transform: 'scale(0.90)' }} />
                                {/* <figcaption>Output</figcaption> */}
                            </figure>
                            <svg slot="handle" class="custom-animated-handle" xmlns="http://www.w3.org/2000/svg" width="100" viewBox="-8 -3 16 6">
                                <path stroke="#000" d="M -1 -2 L -3 0 L -1 2 M -1 -2 L -1 2 M 1 -2 L 3 0 L 1 2 M 1 -2 L 1 2" stroke-width="1" fill="#fff" vector-effect="non-scaling-stroke" strokeLinejoin='round'></path>
                            </svg>
                        </ImgComparisonSlider>
                    </Cols>
                    <SingleRow>
                        <h4>background</h4>
                        <SwatchList colors={bgColors} onSwatchChange={handleBgChange} />
                    </SingleRow>
                </ColContainer>
            </div>
        </div>
    );
}
